export default {"src":"/pro/_next/static/media/tia.5e123867.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};